
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entities/[slug]/analytics",
      function () {
        return require("private-next-pages/entities/[slug]/analytics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entities/[slug]/analytics"])
      });
    }
  